import { StrictMode, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MMProvider, PrivateLayout } from '@machinemetrics/mm-react-tools';
import './index.css';
import './styles/carbideNavyTheme.css';
import App from './App.jsx';

function Root() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch('/default.json')
      .then(r => r.json())
      .then(setConfig)
      .catch(() => setConfig({}));
  }, []);

  if (!config) {
    return (
      <div style={{ minHeight: '100vh', background: '#0D1B2A', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a89060' }}>
        Loading…
      </div>
    );
  }

  const hasAuth = !!(config.clientId && config.clientId !== 'YOUR_CLIENT_ID' && config.clientId !== '' && config.clientId !== 'CLIENT_ID');

  if (hasAuth) {
    // MMProvider supplies its own Router — do NOT wrap in BrowserRouter
    return (
      <StrictMode>
        <MMProvider
          clientId={config.clientId}
          clientSecret={config.clientSecret}
          scope="reporting"
          releaseStage={config.releaseStage || 'production'}
          urls={config.urls}
        >
          <Routes>
            <Route path="/unauthorized" element={<div style={{ padding: 40, color: '#a89060' }}>Unauthorized — contact your MachineMetrics admin.</div>} />
            <Route element={<PrivateLayout />}>
              <Route path="*" element={<App />} />
            </Route>
          </Routes>
        </MMProvider>
      </StrictMode>
    );
  }

  return (
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}

createRoot(document.getElementById('root')).render(<Root />);
